<ng-container *ngIf="!!element?.anexo_principal">
  <div
    class="w-full rounded-tl-2xl bg-white px-10 pt-10 shadow-xl"
    [ngClass]="{
      'rounded-tr-2xl': fullWidth || fullSize,
      'rounded-bl-2xl rounded-br-2xl': fullSize,
      'pb-10': paddingBottom
    }"
  >
    <audio controls class="w-full">
      <source [src]="element.anexo_principal.file" [type]="element.anexo_principal.mimetype" />
      {{ 'geral.audio-error' | translate }}
    </audio>
  </div>
</ng-container>
